import store from '@/core/store'
import { getUserActivities, getLastUserActivity } from '@/app-domains/activity/activities.api'
import { addActivities, addActivity, setFilterType } from '@/core/store/Slices/ActivitiesSlice'
import moment from 'moment'

class ActivitiesService {
  constructor () {
    this.page = 0
    this.activeFilter = 'all'
    this.currentFilterHandler = () => {}
    this.isFetching = false
  }

  async getActivities () {
    if (this.isFetching) { return }
    this.isFetching = true
    const activities = await getUserActivities(this.page, this.activeFilter)
    if (activities) store.dispatch(addActivities(activities))
    store.commit('ACTIVITIES:LOAD')
    this.page++
    setTimeout(() => { this.isFetching = false }, 400)
  }

  async getLastUserActivity () {
    return new Promise((resolve) => {
      getLastUserActivity().then((res) => {
        const activity = res.results[0]
        store.dispatch(addActivity(activity))
        store.commit('ACTIVITIES:added')
        resolve()
      })
    })
  }
  
  getStoredActivities () {
    return store.getState().activities.activities
  }

  applyStoredActivitiesFilter (type) {
    const filters = {
      all: this.retrieveAllActivities.bind(this),
      today: this.retrieveTodayActivities.bind(this),
      'this-week': this.retrieveLastWeekActivities.bind(this)
    }
    const activities = filters[type]()
    this.activeFilter = type
    this.page = 0
    store.dispatch(setFilterType(type))
    store.commit('ACTIVITIES:FILTER', {
      filter: type,
      activities
    })
  }

  getStoredActivityFilter () {
    return store.getState().activities.activitiesFilter
  }

  retrieveAllActivities () {
    return Object.values(this.getStoredActivities())
  }

  retrieveTodayActivities () {
    const activities = this.getStoredActivities()
    const today = moment().format('DD MM YYYY')
    const filterFn = (activity) => today === moment(activity?.date).format('DD MM YYYY')
    this.currentFilterHandler = filterFn
    const filteredActivities = Object.values(activities).filter(filterFn)
    return filteredActivities
  }
  
  retrieveLastWeekActivities () {
    const activities = this.getStoredActivities()
    const lastWeekLimitDate = moment().startOf('isoWeek')
    const filterFn = (activity) => lastWeekLimitDate < moment(activity?.date)
    this.currentFilterHandler = filterFn
    const filteredActivities = Object.values(activities).filter(filterFn)
    return filteredActivities
  }
}

export default new ActivitiesService()
